import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { initSentry, Sentry } from '@/lib/sentry';
import { App } from './App';
import './styles/globals.css';
import 'leaflet/dist/leaflet.css';

initSentry();

const root = document.getElementById('root');
if (!root) throw new Error('Elemento #root não encontrado.');

createRoot(root).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>,
);

function ErrorFallback() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4 px-4 text-center">
      <h1 className="font-display text-2xl font-semibold">Algo deu errado.</h1>
      <p className="text-muted">A equipe foi notificada. Tente recarregar a página.</p>
      <button
        type="button"
        onClick={() => location.reload()}
        className="rounded-lg bg-brand px-4 py-2 font-medium text-white"
      >
        Recarregar
      </button>
    </div>
  );
}
